var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "18px",
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pool-List",
    transform: "translate(-354.000000, -795.000000)",
    fill: "#C5C5C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(130.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(142.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(82.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9975556,7.4595814 L10.7948036,7.4595814 L10.7948036,4.51204134 C10.7948036,2.02427132 8.8631447,7.6378754e-15 6.4890155,7.6378754e-15 C4.1148863,7.6378754e-15 2.18322739,2.02417054 2.18322739,4.51204134 L2.18322739,7.4595814 L0.980475452,7.4595814 C0.439077519,7.4595814 -3.8189377e-15,7.89849096 -3.8189377e-15,8.44005685 L-3.8189377e-15,15.9498243 C-3.8189377e-15,16.4913566 0.438909561,16.9302997 0.980475452,16.9302997 L11.9978915,16.9302997 C12.5394238,16.9302997 12.9783669,16.4913902 12.9783669,15.9498243 L12.9782357,8.44005685 C12.9781045,7.89852455 12.5391918,7.4595814 11.9976595,7.4595814 L11.9975556,7.4595814 Z M6.94367959,12.3797623 L6.94367959,14.4288579 L6.03394832,14.4288579 L6.03407956,12.3797623 C5.56732246,12.1972382 5.23550334,11.7459871 5.23550334,11.2145323 C5.23550334,10.5222403 5.79658602,9.96115762 6.48887801,9.96115762 C7.18117,9.96115762 7.74225269,10.5222403 7.74225269,11.2145323 C7.74225269,11.7458191 7.41040334,12.1972248 6.94367646,12.3797623 L6.94367959,12.3797623 Z M9.5818062,7.4595814 L3.39588889,7.4595814 L3.39588889,4.51204134 C3.39588889,2.69298191 4.78339535,1.21309819 6.48881395,1.21309819 C8.19423256,1.21309819 9.58173902,2.69298191 9.58173902,4.51204134 L9.5818062,7.4595814 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.4871d42ec6996730049b1a2b87fdcd7e.svg";
export { ForwardRef as ReactComponent };